import React from 'react';
import PF2MMaskTextField from '../../PF2MMaskTextField';

export default function TimeCell(p) {
  const curP = p;

  const helperText = curP.error
    ? (curP.helperText || true) // red line with empty message
    : curP.helperText; // normal message

  return (
    <PF2MMaskTextField
      style={{ height: '28px' }}
      mask="99:99:99"
      value={curP.value}
      error={curP.error}
      helperText={helperText}
      InputProps={{ style: { fontSize: 13 } }}
      onChange={e => curP.bulkEdit(e, curP)}
    />
  );
}
